import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NewsCard from '../components/NewsCard';

const mapStateToProps = ({ allPage, newsEvent }) => {
  const newsWP = _.map(allPage, (value, key) => {
    // console.log(
    //   'news',
    //   _.find(value, page => _.get(page, 'slug') === 'news-event')
    // );
    return {
      key,
      ..._.find(value, page => _.get(page, 'slug') === 'news-event')
    };
  });

  const newsSection = _.keyBy(newsWP, 'key');
  // console.log('news keyBy', newsSection);

  return {
    content: {
      ..._.keyBy(
        _.map(newsSection, (v, k) => {
          return {
            ...v,
            title: _.get(v, 'title.rendered'),
            allNews: _.orderBy(
              _.get(newsEvent, k),
              news => _.get(news, 'date'),
              ['asc']
            )
          };
        }),
        'key'
      )
    }
  };
};

const actions = {};

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};

class NewsEvent extends Component {
  handleOnClick(id) {
    const { history } = this.props;
    history.push(`/news-event/${id}`);
  }
  render() {
    const { content, language } = this.props;
    // console.log(
    //   'render',
    //   language,
    //   content,
    //   _.get(content, `${language}`),
    //   _.get(content, `${language}.title`)
    // );
    return (
      <div className="news-events row no-gutters">
        <div className="news-content offset-1 col-10">
          {/* <h2 className="whiteGray m-bottom-40">news & event</h2> */}
          <h2
            className="darkGray m-bottom-40"
            dangerouslySetInnerHTML={{
              __html: _.get(content, `${language}.title`)
            }}
          />
          <div className="row custom-gutter">
            {_.map(_.get(content, `${language}.allNews`), (data) => {
              console.log('data', data);
              return (
                <div
                  key={`${language}-${data.slug}`}
                  className="col-12 col-sm-6 col-lg-4 custom-gutter"
                >
                  <NewsCard
                    img={_.get(data, ['acf', 'cover_image', 'url'])}
                    className=""
                    // title={`${_.get(data, 'id')} - ${_.get(data, 'title.rendered')}`}
                    title={_.get(data, 'title.rendered')}
                    onClick={() => this.handleOnClick(data.slug)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsEvent);



// WEBPACK FOOTER //
// ./src/screens/NewsEvent.js